"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findValueObject = findValueObject;
exports.formatCertAge = formatCertAge;
exports.formatDateAge = formatDateAge;
exports.toNumber = toNumber;
exports.toString = toString;
exports.trim = trim;

var _tools = require("./tools");

var _validates = require("./validates");

/**
 * 转换数字
 * @param {string | number} text  内容
 * return {number}
 */
function toNumber(text) {
  if (typeof text === 'number') {
    return text;
  }

  return parseInt(text, 10);
}
/**
 * 转换字符串
 * @param {string | number} text  内容
 * return {string}
 */


function toString(text) {
  if (typeof text === 'number') {
    return text.toString();
  }

  return text;
}
/**
 * 去掉前后空格
 * @param {string | number} value 值
 * return {string | number}
 */


function trim(value) {
  // isWindows
  // 环境 系统window10／chrome浏览器／搜狗输入框／连打，按下失效
  if (typeof value !== 'string' || _tools.isWindows) {
    return value;
  }

  if (typeof value === 'string') {
    if (!String.prototype.trim) {
      return value.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }

    return value.trim();
  }

  return value;
}
/**
 * 出生日期转换年龄
 * @param  {any}    date       时间
 * @param  {object} opts       参数
 * @config {string} currentDate  当前默认获取当天时间，today 获取当天时间、tomorrow 获取明天时间、yesterday 获取昨天时间
 * return number
 */


function formatDateAge(date, opts) {
  if (!date) {
    return date || 0;
  } // 转换标准yyyy-MM-dd


  if (typeof date === 'string' && date.length === 8) {
    date = "".concat(date.substr(0, 4), "-").concat(date.substr(4, 2), "-").concat(date.substr(6, 2));
  }

  var today = new Date();
  var keys = {
    today: 0,
    tomorrow: 1,
    yesterday: -1
  }; // 默认获取时间设置

  if (opts && opts.currentDate && typeof keys[opts.currentDate] !== 'undefined') {
    today.setDate(today.getDate() + keys[opts.currentDate]);
  }

  var birthDate = new Date(date.toString().replace(/-/g, '/'));
  var age = today.getFullYear() - birthDate.getFullYear();
  var monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) {
    age -= 1;
  }

  return Number.isNaN(age) ? 0 : age;
}
/**
 * 查询目标是对象解析
 * @param {string} value   内容
 * @param {string} name    key值
 */


function findValueObject(value) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

  if (value && (0, _tools.isObject)(value)) {
    value = value[name];
  }

  return value;
}
/**
 * 证件号转换年龄
 * @param {string} value   值
 */


function formatCertAge(value) {
  if (value && (0, _validates.idCard)(value) && value.length === 18) {
    var birthday = "".concat(value.substr(6, 4), "/").concat(Number(value.substr(10, 2)), "/").concat(Number(value.substr(12, 2)));
    return formatDateAge(birthday);
  }

  return 0;
} // indexOf